import React from 'react';
import { Spinner } from '@isyc-react/design/bootstrap';
import { pageRelativeDim } from "../../../base/page";
export const ViewPdfPagePlaceholder = props => {
  const {
    dims,
    scale,
    rotate
  } = props;
  const contextStyle = React.useMemo(() => {
    // TODO use some default dims??
    const contextDims = dims !== null && dims !== void 0 ? dims : {
      originalHeight: 800,
      originalWidth: 500
    }; // TODO check how to do this and loading if not dims??

    const {
      pageHeight,
      pageWidth
    } = pageRelativeDim(contextDims, rotate);
    return {
      height: `${pageHeight * scale}px`,
      width: `${pageWidth * scale}px`
    };
  }, [scale, rotate, dims]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    style: contextStyle
  }));
};
export const ViewPdfDataRangeLoadingPagePlaceholder = props => {
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Spinner, {
    animation: "border",
    className: "my-5"
  }));
};